<script setup lang="ts">
const galeryPartner1 = [
  '/img/partner-assets/partner-1.png',
  '/img/partner-assets/partner-2.png',
  '/img/partner-assets/partner-3.png',
  '/img/partner-assets/partner-4.png',
  '/img/partner-assets/partner-5.png',
  '/img/partner-assets/partner-6.png',
]

const galeryPartner2 = [
  '/img/partner-assets/partner-7.png',
  '/img/partner-assets/partner-8.png',
  '/img/partner-assets/partner-9.png',
]

const ornament2 = `<svg width="8" height="26" viewBox="0 0 8 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.64645 25.3536C3.84171 25.5488 4.15829 25.5488 4.35355 25.3536L7.53553 22.1716C7.7308 21.9763 7.7308 21.6597 7.53553 21.4645C7.34027 21.2692 7.02369 21.2692 6.82843 21.4645L4 24.2929L1.17157 21.4645C0.97631 21.2692 0.659727 21.2692 0.464465 21.4645C0.269203 21.6597 0.269203 21.9763 0.464465 22.1716L3.64645 25.3536ZM4 0L3.5 -2.18561e-08L3.5 25L4 25L4.5 25L4.5 2.18561e-08L4 0Z" fill="#5D5C62"/></svg>`
</script>

<template>
  <section id="home" class="relative overflow-hidden">
    <div class="container mx-auto pt-18">
      <div class="grid items-start grid-cols-12 min-h-[880px] xs:min-h-0">
        <div class="col-span-7 xs:col-span-12 ml-[40px] xs:ml-[20px] xs:pr-5">
          <div class="relative pt-[240px] xs:pt-[100px]">
            <AnimateOnce initial-class="opacity-0 translate-y-10" animated-class="opacity-100 translate-y-0" :duration="700">
              <h2 class="text-[42px] xs:text-[32px] z-[3] text-neutral-800 leading-tight font-medium font-geist">
                Bisnis Lebih Optimal <br class="xs:hidden">
                dengan Online Payment Facilitator <br class="xs:hidden">
                <span class="font-bold textGradientV2">Rintisan Billing Partner</span>
              </h2>
            </AnimateOnce>
            <AnimateOnce initial-class="opacity-0 translate-y-10" animated-class="opacity-100 translate-y-0" :duration="700" :delay="150">
              <p class="mt-5 text-lg font-normal xs:mt-[10px] xs:text-base text-neutral-600 leading-relaxed font-geist">
                #MakinRingan dengan Solusi Billing & Payment Gateway
                <br class="xs:hidden">
                Terintegrasi semua Pembayaran untuk Bisnis Anda
                <br class="xs:hidden">
                yang Lebih Terukur
              </p>
            </AnimateOnce>
            <AnimateOnce initial-class="opacity-0 translate-y-10" animated-class="opacity-100 translate-y-0" :duration="700" :delay="300">
              <button
                class="bgGradientV2 text-white mt-[48px] xs:mt-[36px] py-3 px-6 rounded-md text-base font-semibold shadow-sm hover:opacity-90 transition-opacity font-geist"
                @click="navigateTo('/daftar')"
              >
                Mulai Sekarang
              </button>
            </AnimateOnce>
            <img
              class="absolute xs:top-[50px] top-[130px] -left-[40px] xs:-left-[10px] object-contain w-[155px]"
              src="/img/content-assets/ornament-1.png"
              alt="ornament"
            >
          </div>
          <div class="w-max mt-[120px] xs:mb-[36px] xs:mt-[36px]">
            <span class="text-sm font-normal text-neutral-500 tracking-wide font-geist">Mulai Explor</span>
            <div class="flex items-center justify-center mt-1" v-html="ornament2" />
          </div>
        </div>

        <div class="relative w-full col-span-5 xs:col-span-12 xs:h-[600px] md:h-[880px]">
          <div class="w-[4000px] md:absolute xs:absolute left-[40px] xs:-left-[30px] bg-[#fafafa] border-l border-neutral-200 top-0 bottom-0 xs:h-[700px]" />
          <img
            src="/img/content-assets/ppl-landing.png"
            class="max-w-[950px] h-[900px] -left-[100px] bottom-0 xs:max-w-[800px] xs:h-[700px] xs:-left-[170px] xs:absolute md:absolute"
            alt="ppl-landing"
          >
          <img
            src="/img/content-assets/ppl-ornament-1.png"
            class="max-w-[275px] max-h-[275px] -left-[80px] top-[420px] xs:absolute object-contain md:absolute"
            alt="ornament-1"
          >
          <img
            src="/img/content-assets/ppl-ornament-2.png"
            class="max-w-[260px] max-h-[200px] xs:-right-[70px] -right-[130px] top-[400px] xs:top-[300px] xs:absolute object-contain md:absolute"
            alt="ornament-2"
          >
        </div>
      </div>
    </div>
  </section>

  <section class="bg-[#FAFAFA]">
    <div class="container mx-auto py-[80px] xs:px-4">
      <AnimateOnce initial-class="opacity-0 translate-y-8" animated-class="opacity-100 translate-y-0" :duration="600">
        <h2 class="text-lg text-center xs:text-base font-geist">
          <span class="font-bold textGradientV2">Rintisan Billing Partner</span>
          sudah menjadi <br class="xs:hidden">
          bagian dari 8000+ perusahaan dan pelaku usaha/bisnis
        </h2>
      </AnimateOnce>
      <AnimateOnce initial-class="opacity-0 translate-y-8" animated-class="opacity-100 translate-y-0" :duration="600" :delay="100">
        <div class="pb-2 xs:overflow-x-auto scrollBehaviorX">
          <div class="flex items-center justify-center gap-4 mt-8 xs:justify-start xs:items-start">
            <div
              v-for="img in galeryPartner1"
              :key="img"
              class="flex items-center justify-center px-6 py-4 bg-white border rounded-lg shadow-smallShadow border-neutral-200"
            >
              <img :src="img" alt="partner" class="object-contain xs:min-w-[30px] xs:max-w-max w-min h-[30px]">
            </div>
          </div>
          <div class="flex items-center justify-center gap-4 mt-8 xs:items-start xs:justify-start">
            <div
              v-for="img in galeryPartner2"
              :key="img"
              class="flex items-center justify-center px-6 py-4 bg-white border rounded-lg shadow-smallShadow border-neutral-200"
            >
              <img :src="img" alt="partner" class="object-contain w-min xs:min-w-[30px] xs:max-w-max h-[30px]">
            </div>
            <div class="flex items-center justify-center px-6 py-4 bg-white border rounded-lg shadow-smallShadow border-neutral-200">
              <h2 class="text-lg font-geist">
                ++
              </h2>
            </div>
          </div>
        </div>
      </AnimateOnce>
    </div>
  </section>
</template>
